<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper" v-if="member">
    <!-- MOBILE VIEW (Aesthetic Minimalist) -->
    <div class="content d-lg-none mob-kios-details p-0">
        <!-- Sticky Header Overlay -->
        <div class="mob-sticky-header">
           <a href="javascript:void(0);" @click="router.push('/people/kios-list')" class="back-btn-blur shadow-sm">
              <vue-feather type="arrow-left" size="20"></vue-feather>
           </a>
            <div class="d-flex gap-2">
               <button v-if="$hasPermission('ssp', 'members', 'edit')" @click="editKios" class="action-btn-blur shadow-sm text-primary border-0 bg-white-blur">
                  <vue-feather type="edit-3" size="18"></vue-feather>
               </button>
               <router-link v-if="$hasPermission('ssp', 'orders', 'create')" :to="'/purchases/add-order?member_id=' + member.id" class="action-btn-blur shadow-sm text-success">
                  <vue-feather type="shopping-cart" size="18"></vue-feather>
               </router-link>
            </div>
        </div>

        <!-- Cover & Logo -->
        <div class="mob-header-container">
           <div class="mob-cover-wrapper">
              <img v-if="member.foto_toko" :src="getImageUrl(member.foto_toko)" class="mob-cover-img" @click="showImage(getImageUrl(member.foto_toko))">
              <div v-else class="mob-cover-placeholder"></div>
              <div class="mob-cover-overlay"></div>
           </div>
           <div class="mob-profile-float">
              <div class="mob-logo-box shadow-lg" @click="showImage(getImageUrl(member.logo_toko || member.foto_toko))">
                 <img :src="getImageUrl(member.logo_toko || member.foto_toko)" class="w-100 h-100 object-fit-cover">
              </div>
              <div class="mob-shop-basic ms-3 mt-4">
                 <h4 class="fw-800 text-dark mb-1">{{ member.nama_toko }}</h4>
                 <div class="d-flex align-items-center gap-1 text-muted smallest fw-bold uppercase">
                    <vue-feather type="user" size="10"></vue-feather>
                    {{ member.nama_member }}
                 </div>
              </div>
           </div>
        </div>

        <!-- Action & Stats Info -->
        <div class="px-4 mt-5">
           <div class="row g-3">
              <div class="col-6">
                 <div class="stat-pill-mob bg-white shadow-xs">
                    <span class="label">PENDAMPING</span>
                    <span class="value text-success">{{ member.pendamping?.nama_pendamping || 'SDV ADMIN' }}</span>
                 </div>
              </div>
              <div class="col-6">
                 <div class="stat-pill-mob bg-white shadow-xs">
                    <span class="label">TOTAL PRODUK</span>
                    <span class="value text-dark">{{ member.products?.length || 0 }} SKU</span>
                 </div>
              </div>
           </div>
        </div>

         <!-- Info Pemilik (New Mobile UX Enhancement) -->
         <div class="px-4 mt-4">
            <div class="p-3 bg-white shadow-xs rounded-4 d-flex align-items-center gap-3 border border-light-dark">
               <div class="flex-shrink-0">
                  <img v-if="member.foto_profil" :src="getImageUrl(member.foto_profil)" class="rounded-circle border border-2 border-success p-1 shadow-sm" style="width: 54px; height: 54px; object-fit: cover;" @click="showImage(getImageUrl(member.foto_profil))">
                  <div v-else class="owner-avatar-placeholder bg-success-soft text-success">
                     <vue-feather type="user" size="24"></vue-feather>
                  </div>
               </div>
               <div class="flex-fill">
                  <label class="smallest fw-800 text-muted uppercase tracking-wider mb-1 d-block">Pemilik Kios</label>
                  <h6 class="fw-bold mb-0 text-dark" style="font-size: 15px;">{{ member.nama_member }}</h6>
                  <div class="d-flex align-items-center gap-1 mt-1">
                     <small class="text-muted fw-bold">{{ member.nomor_handphone || '-' }}</small>
                  </div>
               </div>
            </div>
         </div>

        <!-- Details Section -->
        <div class="mt-4 px-4 pb-5">
           <!-- Alamat -->
           <div class="mb-4">
              <label class="smallest fw-800 text-muted uppercase tracking-wider mb-2">Alamat Lengkap</label>
              <div class="p-3 bg-light-soft rounded-4 border-light d-flex gap-2">
                 <vue-feather type="map-pin" size="14" class="text-success mt-1"></vue-feather>
                 <span class="small text-dark lh-base">{{ member.alamat }}</span>
              </div>
           </div>

           <!-- Produk List -->
           <div class="mb-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                 <label class="smallest fw-800 text-dark uppercase tracking-wider">Produk Terdaftar</label>
                  <button v-if="$hasPermission('ssp', 'members', 'edit')" @click="triggerAddProduct" class="btn-add-pill bg-success-soft text-success">
                     <vue-feather type="plus" size="14" class="me-1"></vue-feather>
                     TAMBAH
                  </button>
              </div>
              <div class="mob-scroll-list">
                 <div v-for="prod in member.products" :key="'mob-p-'+prod.id" class="mob-item-row bg-white shadow-xs mb-2">
                    <div class="d-flex align-items-center flex-fill">
                       <span class="small fw-bold text-dark text-uppercase letter-spacing-1">{{ prod.nama_produk }}</span>
                    </div>
                     <button v-if="$hasPermission('ssp', 'members', 'edit')" @click="confirmRemoveProduct(prod)" class="btn-delete-circle">
                        <vue-feather type="trash-2" size="14"></vue-feather>
                     </button>
                 </div>
                 <div v-if="!member.products?.length" class="text-center py-3 text-muted smallest italic">Belum ada produk</div>
              </div>
           </div>

           <!-- Sumber List -->
           <div class="mb-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                 <label class="smallest fw-800 text-dark uppercase tracking-wider">Sumber Barang</label>
                  <button v-if="$hasPermission('ssp', 'members', 'edit')" @click="triggerAddSource" class="btn-add-pill bg-blue-soft text-blue">
                     <vue-feather type="plus" size="14" class="me-1"></vue-feather>
                     TAMBAH
                  </button>
              </div>
              <div class="mob-scroll-list">
                 <div v-for="src in member.sources" :key="'mob-s-'+src.id" class="mob-item-row bg-white shadow-xs mb-2">
                    <div class="d-flex align-items-center flex-fill">
                       <span class="small fw-bold text-dark text-uppercase letter-spacing-1">{{ src.nama_sumber }}</span>
                    </div>
                     <button v-if="$hasPermission('ssp', 'members', 'edit')" @click="confirmRemoveSource(src)" class="btn-delete-circle">
                        <vue-feather type="trash-2" size="14"></vue-feather>
                     </button>
                 </div>
                 <div v-if="!member.sources?.length" class="text-center py-3 text-muted smallest italic">Belum ada sumber</div>
              </div>
           </div>

           <!-- Dokumen -->
           <div class="mb-4">
              <label class="smallest fw-800 text-muted uppercase tracking-wider mb-2">Dokumen Digital</label>
              <div class="row g-3">
                 <div v-if="member.foto_ktp" class="col-6">
                    <div class="doc-card-mob shadow-xs" @click="showImage(getImageUrl(member.foto_ktp))">
                       <img :src="getImageUrl(member.foto_ktp)">
                       <div class="overlay">FOTO KTP</div>
                    </div>
                 </div>
                 <div v-if="member.barcode_image" class="col-6">
                    <div class="doc-card-mob shadow-xs bg-white p-2" @click="showImage(getImageUrl(member.barcode_image))">
                       <img :src="getImageUrl(member.barcode_image)" class="object-fit-contain">
                       <div class="overlay">QUICK SCAN</div>
                    </div>
                 </div>
              </div>
           </div>

           <!-- Riwayat PO Button -->
           <div v-if="$hasPermission('ssp', 'orders', 'view')" class="mt-4 pt-2">
              <button class="btn btn-success w-100 rounded-pill py-3 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2" data-bs-toggle="modal" data-bs-target="#riwayatPOModal">
                 <vue-feather type="clock" size="18"></vue-feather>
                 LIHAT RIWAYAT PESANAN
              </button>
           </div>
        </div>
    </div>

    <!-- DESKTOP VIEW -->
    <div class="content d-none d-lg-block">
      <!-- Page Header -->
      <div class="page-header mb-4">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4 class="text-uppercase fw-bold">{{ member.nama_toko }}</h4>
            <h6>Kios SSP / Detail</h6>
          </div>
        </div>
        <div class="page-btn d-flex gap-2">
            <button v-if="$hasPermission('ssp', 'members', 'edit')" @click="editKios" class="btn btn-primary text-white">
                <vue-feather type="edit-3" class="me-2" style="width: 18px;"></vue-feather>Edit Kios
            </button>
            <button v-if="$hasPermission('ssp', 'orders', 'view')" class="btn btn-success text-white" data-bs-toggle="modal" data-bs-target="#riwayatPOModal">
                <vue-feather type="shopping-bag" class="me-2" style="width: 18px;"></vue-feather>Riwayat PO
            </button>
            <router-link v-if="$hasPermission('ssp', 'orders', 'create')" :to="'/purchases/add-order?member_id=' + member.id" class="btn btn-black">
                <vue-feather type="plus" class="me-2" style="width: 18px;"></vue-feather>Buat PO
            </router-link>
        </div>
      </div>

      <div class="row">
        <!-- Left Column -->
        <div class="col-lg-4">
          <!-- Profile Card (Modern square style) -->
          <div class="card border-0 shadow-sm overflow-hidden mb-4 detail-card">
            <!-- Cover Photo -->
            <div v-if="member.foto_toko" class="cover-photo-container cursor-pointer" @click="showImage(getImageUrl(member.foto_toko))">
              <img :src="getImageUrl(member.foto_toko)" alt="Store Cover" class="w-100 object-fit-cover">
            </div>
            
            <div class="card-body pt-0 position-relative">
              <!-- Overlapping Logo (Square) - Only show if it exists -->
              <div v-if="member.logo_toko" class="profile-logo-wrapper shadow-sm border border-4 border-white rounded-3 bg-white cursor-pointer" @click="showImage(getImageUrl(member.logo_toko))">
                <img :src="getImageUrl(member.logo_toko)" alt="Logo">
              </div>
              <!-- Spacer to keep text position same if logo is missing -->
              <div v-else class="logo-spacer"></div>

              <!-- Store Info below Logo -->
              <div class="store-info-header ps-3">
                <h4 class="fw-bold mb-1 text-dark text-capitalize">{{ member.nama_toko }}</h4>
                <p class="text-muted small mb-3 d-flex align-items-center">
                  <span>{{ member.alamat }}</span>
                </p>
              </div>
              
              <div class="mb-4 border-top pt-3 ps-3">
                <label class="text-success small fw-bold text-uppercase mb-3 d-block letter-spacing-1">PEMILIK KIOS</label>
                <div class="d-flex align-items-center">
                  <div v-if="member.foto_profil" class="flex-shrink-0 me-3 cursor-pointer" @click="showImage(getImageUrl(member.foto_profil))">
                    <img :src="getImageUrl(member.foto_profil)" class="rounded-circle border border-2 border-success p-1 profile-owner-img">
                  </div>
                  <div class="flex-grow-0">
                    <h6 class="fw-bold mb-1">{{ member.nama_member }}</h6>
                    <div class="text-success d-flex align-items-center">
                      <small>{{ member.nomor_handphone || '-' }}</small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row g-2">
                <div class="col-6">
                  <div class="bg-primary bg-opacity-10 rounded p-3 text-center border border-success border-opacity-10">
                    <vue-feather type="user" class="text-success mb-2"></vue-feather>
                    <div class="text-muted small text-uppercase fw-bold mb-1" style="font-size: 10px;">Pendamping</div>
                    <div class="fw-bold text-dark">{{ member.pendamping?.nama_pendamping || 'SUYADI' }}</div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="bg-success bg-opacity-10 rounded p-3 text-center border border-success border-opacity-10">
                    <vue-feather type="box" class="text-success mb-2"></vue-feather>
                    <div class="text-muted small text-uppercase fw-bold mb-1" style="font-size: 10px;">Produk</div>
                    <div class="fw-bold text-dark">{{ member.products?.length || 0 }} Item</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Documents Card -->
          <div v-if="member.foto_ktp || member.barcode_image" class="card border-0 shadow-sm mb-4 detail-card">
            <div class="card-header bg-white py-3 border-0">
              <h6 class="fw-bold mb-0 d-flex align-items-center text-dark">
                <vue-feather type="file-text" class="me-2 text-warning" style="width: 18px;"></vue-feather>
                Dokumen Kios
              </h6>
            </div>
            <div class="card-body pt-0">
              <div class="row g-3">
                <div v-if="member.foto_ktp" class="col-6 text-center">
                  <div class="p-2 border rounded bg-light position-relative">
                    <div class="small fw-bold text-muted mb-2 d-flex align-items-center justify-content-center">
                      <vue-feather type="image" class="me-1" style="width: 12px;"></vue-feather>Foto KTP
                    </div>
                    <img :src="getImageUrl(member.foto_ktp)" class="img-fluid rounded shadow-sm cursor-pointer" style="height: 100px; width: 100%; object-fit: cover;" @click="showImage(getImageUrl(member.foto_ktp))">
                  </div>
                </div>
                <div v-if="member.barcode_image" class="col-6 text-center">
                  <div class="p-2 border rounded bg-white">
                    <div class="small fw-bold text-muted mb-2 d-flex align-items-center justify-content-center">
                      <vue-feather type="grid" class="me-1" style="width: 12px;"></vue-feather>QR Code
                    </div>
                    <img :src="getImageUrl(member.barcode_image)" class="img-fluid cursor-pointer" style="height: 100px; width: 100%; object-fit: contain;" @click="showImage(getImageUrl(member.barcode_image))">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Map Card -->
          <div class="card border-0 shadow-sm mb-4 detail-card">
            <div class="card-header bg-white py-3 border-0">
              <h6 class="fw-bold mb-0 d-flex align-items-center text-dark">
                <vue-feather type="map" class="me-2 text-success" style="width: 18px;"></vue-feather>
                Lokasi Kios
              </h6>
            </div>
            <div class="card-body p-0 position-relative">
              <div id="map-container" style="height: 250px; background: #eee;">
                <l-map ref="map" v-if="mapCoords" :zoom="15" :center="mapCoords" :use-global-leaflet="false">
                  <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                  <l-marker :lat-lng="mapCoords"></l-marker>
                </l-map>
                <div v-else class="h-100 d-flex align-items-center justify-content-center text-muted">
                    <div class="text-center">
                        <vue-feather type="alert-circle" class="mb-2"></vue-feather>
                        <p class="small">Koordinat lokasi tidak tersedia</p>
                    </div>
                </div>
              </div>
              <div class="p-3">
                <a :href="googleMapsUrl" target="_blank" class="btn btn-outline-success w-100 d-flex align-items-center justify-content-center fw-bold">
                  <vue-feather type="navigation" class="me-2" style="width: 16px;"></vue-feather>
                  Petunjuk Arah (Maps)
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-lg-8">
          <!-- Products Section -->
          <div class="card border-0 shadow-sm mb-4 product-section detail-card">
            <div class="card-header bg-white py-3 border-0 d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <h5 class="fw-bold mb-0">Produk SDV</h5>
              </div>
              <button 
                v-if="$hasPermission('ssp', 'members', 'edit')"
                class="btn btn-dark btn-sm rounded-circle d-flex align-items-center justify-content-center" 
                style="width: 28px; height: 28px; padding: 0;"
                data-bs-toggle="modal"
                data-bs-target="#addProductModal"
              >
                <vue-feather type="plus" style="width: 16px;"></vue-feather>
              </button>
            </div>
            <div class="card-body pt-0">
                <div class="list-group list-group-flush border-top border-bottom">
                    <div v-for="prod in member.products" :key="prod.id" class="list-group-item d-flex justify-content-between align-items-center py-3 ps-3 pe-2 border-bottom hover-bg-light transition">
                        <div class="d-flex align-items-center">
                            <span class="status-dot status-active me-3"></span>
                            <span class="fw-bold text-dark text-uppercase small">{{ prod.nama_produk }}</span>
                        </div>
                        <a v-if="$hasPermission('ssp', 'members', 'edit')" href="javascript:void(0);" class="btn-delete-item" @click="confirmRemoveProduct(prod)">
                            <vue-feather type="x" style="width: 14px;"></vue-feather>
                        </a>
                    </div>
                    <div v-if="!member.products?.length" class="py-4 text-center text-muted border-light">
                        Belum ada produk SDV ditautkan.
                    </div>
                </div>
            </div>
          </div>

          <!-- Sources Section -->
          <div class="card border-0 shadow-sm mb-4 source-section detail-card">
            <div class="card-header bg-white py-3 border-0 d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <h5 class="fw-bold mb-0">Sumber Barang</h5>
              </div>
              <button 
                v-if="$hasPermission('ssp', 'members', 'edit')"
                class="btn btn-dark btn-sm rounded-circle d-flex align-items-center justify-content-center" 
                style="width: 28px; height: 28px; padding: 0;"
                data-bs-toggle="modal"
                data-bs-target="#addSourceModal"
              >
                <vue-feather type="plus" style="width: 16px;"></vue-feather>
              </button>
            </div>
            <div class="card-body pt-0">
                <div class="list-group list-group-flush border-top border-bottom">
                    <div v-for="source in member.sources" :key="source.id" class="list-group-item d-flex justify-content-between align-items-center py-3 ps-3 pe-2 border-bottom hover-bg-light transition">
                        <div class="d-flex align-items-center">
                            <span class="status-dot status-active me-3"></span>
                            <span class="fw-bold text-dark text-uppercase small">{{ source.nama_sumber }}</span>
                        </div>
                        <a v-if="$hasPermission('ssp', 'members', 'edit')" href="javascript:void(0);" class="btn-delete-item" @click="confirmRemoveSource(source)">
                            <vue-feather type="x" style="width: 14px;"></vue-feather>
                        </a>
                    </div>
                    <div v-if="!member.sources?.length" class="py-4 text-center text-muted border-light">
                        Belum ada sumber barang ditautkan.
                    </div>
                </div>
            </div>
          </div>

          <!-- PO History Section -->
          <div v-if="$hasPermission('ssp', 'orders', 'view')" class="card border-0 shadow-sm mb-4 detail-card">
            <div class="card-header bg-white py-3 border-0 d-flex justify-content-between align-items-center">
              <h6 class="fw-bold mb-0 d-flex align-items-center text-dark">
                <vue-feather type="rotate-ccw" class="me-2 text-success" style="width: 18px;"></vue-feather>
                Riwayat PO Terakhir
              </h6>
              <button class="btn btn-link btn-sm fw-bold text-success p-0" data-bs-toggle="modal" data-bs-target="#riwayatPOModal">
                Lihat Semua
              </button>
            </div>
            <div class="card-body border-top p-0">
              <div class="table-responsive" v-if="historyOrders.length > 0">
                <table class="table table-hover mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th class="ps-4">ID PO</th>
                      <th>Tanggal</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="o in historyOrders.slice(0, 5)" :key="o.id" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#riwayatPOModal">
                      <td class="ps-4"><span class="badge bg-light text-primary">#{{ o.id }}</span></td>
                      <td>{{ formatDate(o.tanggal_order) }}</td>
                      <td>
                        <span class="badge bg-success">COMPLETED</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="p-4 text-center text-muted border-light">
                <small>Belum ada riwayat PO</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Riwayat PO Modal component -->
  <RiwayatPOModal v-if="member" :memberId="member.id" :memberName="member.nama_toko" />

  <!-- Add Product Modal -->
  <div class="modal fade" id="addProductModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow">
            <div class="modal-header bg-success text-white">
                <h5 class="modal-title fw-bold text-white">Tambah Produk SDV</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-4">
                <div class="mb-3">
                    <label class="form-label fw-bold">Pilih Produk</label>
                    <vue-select 
                        :options="availableProducts" 
                        v-model="selectedProductId" 
                        placeholder="Cari Produk..." 
                        @select="selectedProductId = $event.id"
                    />
                </div>
            </div>
            <div class="modal-footer border-0">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Batal</button>
                <button type="button" class="btn btn-success px-4" @click="addProduct" :disabled="!selectedProductId">
                    Tambah
                </button>
            </div>
        </div>
    </div>
  </div>

  <!-- Add Source Modal -->
  <div class="modal fade" id="addSourceModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow">
            <div class="modal-header bg-info text-white">
                <h5 class="modal-title fw-bold text-white">Tambah Sumber Barang</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-4">
                <div class="mb-3">
                    <label class="form-label fw-bold">Pilih Sumber</label>
                    <vue-select 
                        :options="availableSources" 
                        v-model="selectedSourceId" 
                        placeholder="Cari Sumber..." 
                        @select="selectedSourceId = $event.id"
                    />
                </div>
            </div>
            <div class="modal-footer border-0">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Batal</button>
                <button type="button" class="btn btn-info px-4 text-white" @click="addSource" :disabled="!selectedSourceId">
                    Tambah
                </button>
            </div>
        </div>
    </div>
  </div>

  <!-- Image Lightbox -->
  <vue-easy-lightbox
    :visible="lightboxVisible"
    :imgs="lightboxImgs"
    @hide="handleHide"
  ></vue-easy-lightbox>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import memberService from '@/services/memberService';
import orderService from '@/services/orderService';
import productService from '@/services/productService';
import sourceService from '@/services/sourceService';
import RiwayatPOModal from '@/components/modal/RiwayatPOModal.vue';
import { LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet';
import 'leaflet/dist/leaflet.css';
import Swal from 'sweetalert2';

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        RiwayatPOModal
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const memberId = route.params.id;
        const member = ref(null);
        const historyOrders = ref([]);
        const allProducts = ref([]);
        const allSources = ref([]);
        const selectedProductId = ref("");
        const selectedSourceId = ref("");
        
        // Lightbox state
        const lightboxVisible = ref(false);
        const lightboxImgs = ref([]);

        const apiBaseUrl = process.env.VUE_APP_API_URL || '';

        const loadData = async () => {
            try {
                const data = await memberService.getMember(memberId);
                member.value = data;
                
                // Load PO History for this member - only show completed orders
                const poData = await orderService.getOrders({ member_id: memberId });
                // Filter hanya PO yang sudah 100% terkirim (completed)
                const allOrders = Array.isArray(poData) ? poData : [];
                historyOrders.value = allOrders.filter(o => {
                    const shipped = o.shipped_qty || 0;
                    const total = o.total_qty || 0;
                    return total > 0 && shipped >= total;
                });

                // Load all products and sources for modals - be robust with response types
                const prodData = await productService.getProducts();
                allProducts.value = Array.isArray(prodData) ? prodData : (prodData?.items || []);

                const srcData = await sourceService.getSources();
                allSources.value = Array.isArray(srcData) ? srcData : (srcData?.items || []);
            } catch (error) {
                console.error("Failed to load member detail", error);
            }
        };

        const getImageUrl = (path) => {
            if (!path) return '/assets/img/placeholder.jpg';
            if (path.startsWith('http')) return path;
            const formattedPath = path.startsWith('/') ? path : `/${path}`;
            return `${apiBaseUrl}${formattedPath}`;
        };

        const mapCoords = computed(() => {
            if (member.value && member.value.latitude && member.value.longitude) {
                return [parseFloat(member.value.latitude), parseFloat(member.value.longitude)];
            }
            return null;
        });

        const googleMapsUrl = computed(() => {
            if (member.value && member.value.latitude && member.value.longitude) {
                return `https://www.google.com/maps/dir/?api=1&destination=${member.value.latitude},${member.value.longitude}`;
            }
            return "#";
        });

        const formatDate = (dateStr) => {
            if (!dateStr) return "-";
            return new Date(dateStr).toLocaleDateString('id-ID', { 
                weekday: 'long', 
                day: '2-digit', 
                month: 'long', 
                year: 'numeric' 
            });
        };

        const statusClass = (status) => {
            switch(status) {
                case 'completed': return 'bg-success';
                case 'partial': return 'bg-warning text-dark';
                case 'processing': return 'bg-black text-white';
                default: return 'bg-secondary';
            }
        };

        // Modal filtering
        const availableProducts = computed(() => {
            if (!member.value || !Array.isArray(allProducts.value)) return [];
            const existingIds = new Set((member.value.products || []).map(p => p.id));
            return allProducts.value
                .filter(p => p && p.id && !existingIds.has(p.id))
                .map(p => ({ id: p.id, text: p.nama_produk }));
        });

        const availableSources = computed(() => {
            if (!member.value || !Array.isArray(allSources.value)) return [];
            const existingIds = new Set((member.value.sources || []).map(s => s.id));
            return allSources.value
                .filter(s => s && s.id && !existingIds.has(s.id))
                .map(s => ({ id: s.id, text: s.nama_sumber }));
        });

        // Add/Remove logic
        const addProduct = async () => {
            if (!selectedProductId.value) return;
            const currentIds = (member.value.products || []).map(p => p.id);
            const newIds = [...currentIds, parseInt(selectedProductId.value)];
            
            try {
                await memberService.updateMember(memberId, { product_ids: newIds });
                selectedProductId.value = "";
                
                // Close modal safely
                try {
                    const modalEl = document.getElementById('addProductModal');
                    if (window.bootstrap && window.bootstrap.Modal) {
                        const modal = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
                        modal.hide();
                    } else {
                        const closeBtn = modalEl?.querySelector('.btn-close');
                        if (closeBtn) closeBtn.click();
                    }
                } catch (e) {
                    console.warn("Modal close helper failed", e);
                }

                await loadData();
                Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Produk ditambahkan', showConfirmButton: false, timer: 1500 });
            } catch (error) {
                console.error("Add product error:", error);
                Swal.fire('Error', 'Gagal menambahkan produk', 'error');
            }
        };

        const confirmRemoveProduct = (prod) => {
            Swal.fire({
                title: 'Hapus Produk?',
                text: `Hapus ${prod.nama_produk} dari kios ini?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya, Hapus',
                cancelButtonText: 'Batal',
                confirmButtonColor: '#d33',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const newIds = (member.value.products || []).filter(p => p.id !== prod.id).map(p => p.id);
                    try {
                        await memberService.updateMember(memberId, { product_ids: newIds });
                        await loadData();
                        Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Produk dihapus', showConfirmButton: false, timer: 1500 });
                    } catch (error) {
                        Swal.fire('Error', 'Gagal menghapus produk', 'error');
                    }
                }
            });
        };

        const addSource = async () => {
            if (!selectedSourceId.value) return;
            const currentIds = (member.value.sources || []).map(s => s.id);
            const newIds = [...currentIds, parseInt(selectedSourceId.value)];
            
            try {
                await memberService.updateMember(memberId, { source_ids: newIds });
                selectedSourceId.value = "";
                
                // Close modal safely
                try {
                    const modalEl = document.getElementById('addSourceModal');
                    if (window.bootstrap && window.bootstrap.Modal) {
                        const modal = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
                        modal.hide();
                    } else {
                        const closeBtn = modalEl?.querySelector('.btn-close');
                        if (closeBtn) closeBtn.click();
                    }
                } catch (e) {
                    console.warn("Modal close helper failed", e);
                }

                await loadData();
                Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Sumber ditambahkan', showConfirmButton: false, timer: 1500 });
            } catch (error) {
                console.error("Add source error:", error);
                Swal.fire('Error', 'Gagal menambahkan sumber', 'error');
            }
        };

        const confirmRemoveSource = (source) => {
            Swal.fire({
                title: 'Hapus Sumber?',
                text: `Hapus ${source.nama_sumber} dari kios ini?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya, Hapus',
                cancelButtonText: 'Batal',
                confirmButtonColor: '#d33',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const newIds = (member.value.sources || []).filter(s => s.id !== source.id).map(s => s.id);
                    try {
                        await memberService.updateMember(memberId, { source_ids: newIds });
                        await loadData();
                        Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Sumber dihapus', showConfirmButton: false, timer: 1500 });
                    } catch (error) {
                        Swal.fire('Error', 'Gagal menghapus sumber', 'error');
                    }
                }
            });
        };

        // Lightbox handlers
        const showImage = (url) => {
            if (!url || url.includes('placeholder')) return;
            lightboxImgs.value = [url];
            lightboxVisible.value = true;
        };
        const handleHide = () => {
            lightboxVisible.value = false;
        };

        const editKios = () => {
             router.push(`/people/edit-member/${memberId}`);
        };

        const triggerAddProduct = () => {
           const btn = document.createElement('button');
           btn.setAttribute('data-bs-toggle', 'modal');
           btn.setAttribute('data-bs-target', '#addProductModal');
           document.body.appendChild(btn);
           btn.click();
           document.body.removeChild(btn);
        };

        const triggerAddSource = () => {
           const btn = document.createElement('button');
           btn.setAttribute('data-bs-toggle', 'modal');
           btn.setAttribute('data-bs-target', '#addSourceModal');
           document.body.appendChild(btn);
           btn.click();
           document.body.removeChild(btn);
        };

        onMounted(loadData);

        return {
            member,
            historyOrders,
            getImageUrl,
            mapCoords,
            googleMapsUrl,
            formatDate,
            statusClass,
            availableProducts,
            availableSources,
            selectedProductId,
            selectedSourceId,
            addProduct,
            confirmRemoveProduct,
            addSource,
            confirmRemoveSource,
            lightboxVisible,
            lightboxImgs,
            showImage,
            handleHide,
            editKios,
            triggerAddProduct,
            triggerAddSource,
            router
        };
    }
};
</script>

<style scoped>
/* Mobile Kios Details Aesthetics */
.mob-kios-details {
    background: #fdfdfd;
}

.mob-sticky-header {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    pointer-events: none;
}

.back-btn-blur, .action-btn-blur {
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1e293b;
    pointer-events: auto;
    border: 1px solid rgba(0,0,0,0.05);
}

.mob-header-container {
    position: relative;
    height: 280px;
}

.mob-cover-wrapper {
    height: 220px;
    overflow: hidden;
    position: relative;
}

.mob-cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mob-cover-placeholder {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #029147 0%, #036d36 100%);
}

.mob-cover-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(to top, #fdfdfd, transparent);
}

.mob-profile-float {
    position: absolute;
    bottom: 0;
    left: 20px;
    display: flex;
    align-items: flex-end;
}

.mob-logo-box {
    width: 100px;
    height: 100px;
    background: white;
    border-radius: 20px;
    padding: 4px;
    overflow: hidden;
}

.stat-pill-mob {
    padding: 12px 15px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.stat-pill-mob .label { font-size: 9px; font-weight: 800; color: #94a3b8; letter-spacing: 0.5px; }
.stat-pill-mob .value { font-size: 13px; font-weight: 800; }

.owner-avatar-placeholder {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.border-light-dark {
    border: 1px solid rgba(0,0,0,0.03) !important;
}

.mob-item-row {
    padding: 12px 15px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dot-status { width: 8px; height: 8px; border-radius: 50%; }
.bg-blue { background: #3b82f6; }

.btn-add-pill {
    padding: 6px 12px;
    border-radius: 50px;
    border: none;
    font-size: 10px;
    font-weight: 800;
    display: flex;
    align-items: center;
    transition: transform 0.1s;
}
.btn-add-pill:active { transform: scale(0.95); }

.btn-delete-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff1f2;
    color: #f43f5e;
    transition: all 0.1s;
}
.btn-delete-circle:active {
    background: #f43f5e;
    color: white;
    transform: scale(0.9);
}

.bg-success-soft { background: #ecfdf5; }

.doc-card-mob {
    position: relative;
    height: 120px;
    border-radius: 16px;
    overflow: hidden;
}

.doc-card-mob img { width: 100%; height: 100%; object-fit: cover; }
.doc-card-mob .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.5);
    color: white;
    font-size: 9px;
    font-weight: 800;
    padding: 6px;
    text-align: center;
    backdrop-filter: blur(4px);
}

.fw-800 { font-weight: 800; }
.bg-light-soft { background: #f8fafc; }

/* Desktop Scoped Style Original */
.cover-photo-container {
    height: 160px;
    width: 100%;
    overflow: hidden;
    background-color: #f0f2f5;
}
.cover-photo-container img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}
.cover-photo-container:hover img {
    transform: scale(1.05);
}
.profile-logo-wrapper {
    width: 110px;
    height: 110px;
    margin: -55px 0 15px 15px;
    position: relative;
    z-index: 2;
    overflow: hidden;
}
.profile-logo-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.logo-spacer {
    height: 70px;
}
.profile-owner-img {
    width: 50px;
    height: 50px;
    object-fit: cover;
}
.store-info-header {
    margin-bottom: 20px;
    text-align: left;
}
.detail-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.detail-card:hover {
    box-shadow: 0 10px 20px rgba(0,0,0,0.08) !important;
}
.letter-spacing-1 {
    letter-spacing: 1px;
}
.cursor-pointer {
    cursor: pointer;
}
.hover-bg-light:hover {
    background-color: #f8f9fa !important;
}
.transition {
    transition: all 0.2s ease;
}
.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}
.status-active {
    background-color: #28c76f;
}
.status-info {
    background-color: #0d6efd;
}
.btn-delete-item {
    color: #6c757d;
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid transparent;
}
.btn-delete-item:hover {
    color: #dc3545;
    background: #fff5f5;
    border-color: #ffdada;
}
.btn-black {
    background-color: #1b1b1c;
    color: #fff;
}
.btn-black:hover {
    background-color: #333;
    color: #fff;
}
/* Leaflet fixes */
:deep(.leaflet-control-container) {
    display: none;
}
.profile-img-wrapper::after {
    content: '\f06e';
    font-family: 'Font Awesome 6 Free';
    font-weight: 900;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 2rem;
    opacity: 0;
    transition: opacity 0.3s;
}
.profile-img-wrapper:hover::after {
    opacity: 0.8;
}
.profile-img-wrapper:hover img {
    filter: brightness(0.6) !important;
}
</style>
